export type AffirmationData = {
  text: string
}

export const AFFIRMATION_TYPES = {
  DAILY: 'daily',
  SELF_LOVE: 'self-love',
  WOMEN: 'women',
  ANXIETY: 'anxiety',
  QUOTES: 'quotes',
} as const
export type AffirmationType = (typeof AFFIRMATION_TYPES)[keyof typeof AFFIRMATION_TYPES]
